<template>
  <div>
    <NotificationsDrawer />
    <ServiceErrorDialog />
    <VersionUpdatedDialog />
    <NotificationMessage />
  </div>
</template>

<script>
import NotificationsDrawer from "@/components/global/Drawers/NotificationsDrawer";
import ServiceErrorDialog from "@/components/global/Dialogs/ServiceErrorDialog";
import VersionUpdatedDialog from "@/components/global/Dialogs/VersionUpdatedDialog";
import NotificationMessage from "@/components/global/Messages/NotificationMessage";

export default {
  name: "GlobalComponents",
  components: {
    NotificationMessage,
    NotificationsDrawer,
    ServiceErrorDialog,
    VersionUpdatedDialog,
  },
};
</script>
